var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9292 1.87825C16.7315 1.1439 16.1525 0.56489 15.4182 0.36718C14.0766 -1.19209e-07 8.71011 0 8.71011 0C8.71011 0 3.34369 -2.38419e-07 2.00208 0.35306C1.28184 0.55077 0.688709 1.1439 0.490999 1.87825C0.137939 3.21986 0.137939 6.0019 0.137939 6.0019C0.137939 6.0019 0.137939 8.7981 0.490999 10.1256C0.688709 10.86 1.26772 11.439 2.00208 11.6367C3.35781 12.0039 8.71011 12.0039 8.71011 12.0039C8.71011 12.0039 14.0766 12.0039 15.4182 11.6508C16.1525 11.4531 16.7315 10.8741 16.9292 10.1397C17.2823 8.7981 17.2823 6.0161 17.2823 6.0161C17.2823 6.0161 17.2964 3.21986 16.9292 1.87825Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.00024 8.5721L11.4629 6.0019L7.00024 3.43164V8.5721Z",
    fill: "#0E1015"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.7bfb99b0cbb88e5c4901fdeb4f77acbc.svg";
export { ForwardRef as ReactComponent };